// This type was created to set id's on navigation items between the "new" global navigation and the old header menu.
// They are used for Pendo targeting
export var navigationIds = {
    FINISH_SETUP_NAV_LINK: 'finish-setup-nav-link',
    MAP_NAV_LINK: 'office-nav-link',
    SPACE_MANAGEMENT_NAV_LINK: 'space-management-nav-link',
    SCHEDULE_NAV_LINK: 'schedule-nav-link',
    PEOPLE_NAV_LINK: 'people-nav-link',
    ANALYTICS_NAV_LINK: 'analytics-nav-link',
    VISITS_NAV_LINK: 'visits-nav-link',
    DELIVERIES_NAV_LINK: 'deliveries-nav-link',
    TICKETS_NAV_LINK: 'tickets-nav-link',
    MANAGE_NAV_LINK: 'managenav-link',
    SETUP_NAV_LINK: 'setup-nav-link',
    MEETING_ROOMS_NAV_LINK: 'meeting-rooms-nav-link',
    WORKWEEK_NAV_LINK: 'workweek-nav-link',
    MY_MEETINGS_NAV_LINK: 'my-meetings-nav-link',
    SCENARIO_PLANNING_NAV_LINK: 'scenario-planning-nav-link',
    LAYOUT_TOOL_NAV_LINK: 'layout-tool-nav-link',
    WORKPLACE_DASHBOARD_NAV_LINK: 'workplace-dashboard-nav-link',
    SUPPORT_NAV_LINK: 'robinSupportLink',
    GIVE_FEEDBACK_NAV_LINK: 'robinFeedbackLink',
};
